const Icons = {
  streamKey: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      className="img"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M18 8a6 6 0 0 1-7.743 5.743L8 16H6v2H2v-4l4.257-4.257A6 6 0 1 1 18 8m-6-4a1 1 0 1 0 0 2 2 2 0 0 1 2 2 1 1 0 1 0 2 0 4 4 0 0 0-4-4"
        clipRule="evenodd"
      ></path>
    </svg>
  ),
  emptyBox: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      className="img"
    >
      <rect
        width="19"
        height="19"
        x="0.5"
        y="0.5"
        stroke="#002856"
        rx="3.5"
      ></rect>
    </svg>
  ),
  arrowUp: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      className="img"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M2.34 14.59a10 10 0 0 1 2.589-9.661c3.905-3.905 10.237-3.905 14.142 0s3.905 10.237 0 14.142a10 10 0 0 1-9.66 2.59M15 15V9m0 0H9m6 0L5 19"
      ></path>
    </svg>
  ),
  dateIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      className="img"
    >
      <path
        stroke="#999"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.833 3.333H4.167C3.247 3.333 2.5 4.079 2.5 5v11.666c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-.746 1.667-1.667V5c0-.92-.746-1.667-1.667-1.667M13.333 1.667V5M6.667 1.667V5M2.5 8.333h15"
      ></path>
    </svg>
  ),
  minusIcon: (param?: any) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="24"
        fill="none"
        viewBox="0 0 30 24"
        className="img"
      >
        <path
          stroke={param || "#000"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.276 12h17.212"
        ></path>
      </svg>
    );
  },
  plusIcon: (param?: any) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="24"
        fill="none"
        viewBox="0 0 30 24"
      >
        <path
          stroke={param || "#020202"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15.117 5v14m-8.606-7h17.212"
        ></path>
      </svg>
    );
  },
  editpenIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="38"
      fill="none"
      viewBox="0 0 38 38"
      className="img"
    >
      <g filter="url(#filter0_dd_7203_6806)">
        <rect
          width="28.793"
          height="28.793"
          x="4.414"
          y="2.104"
          fill="#fff"
          rx="14.396"
          shapeRendering="crispEdges"
        ></rect>
        <path
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.199"
          d="M18.81 20.765h4.798m-9.595 0h.893c.26 0 .39 0 .514-.03q.163-.04.308-.127c.107-.066.2-.158.384-.343l6.696-6.696a1.13 1.13 0 0 0-1.599-1.6l-6.696 6.697c-.185.185-.277.277-.343.384q-.088.145-.127.309c-.03.122-.03.253-.03.513z"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_dd_7203_6806"
          width="36.793"
          height="37.793"
          x="0.414"
          y="0.104"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="1"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.02 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7203_6806"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="3"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.04 0"></feColorMatrix>
          <feBlend
            in2="effect1_dropShadow_7203_6806"
            result="effect2_dropShadow_7203_6806"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_7203_6806"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  ),
  copyIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="37"
      fill="none"
      viewBox="0 0 36 37"
      className="img"
    >
      <g filter="url(#filter0_dd_7203_6807)">
        <rect
          width="28.793"
          height="28.793"
          x="3.207"
          y="2.104"
          fill="#fff"
          rx="14.396"
          shapeRendering="crispEdges"
        ></rect>
        <g clipPath="url(#clip0_7203_6807)">
          <path
            stroke="#020202"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.199"
            d="M19.736 14.368v-1.492c0-.597 0-.896-.117-1.124a1.07 1.07 0 0 0-.466-.466c-.228-.116-.526-.116-1.123-.116h-4.051c-.597 0-.896 0-1.124.116-.2.102-.364.265-.466.466-.116.228-.116.527-.116 1.124v4.05c0 .598 0 .896.116 1.124.102.201.265.364.466.466.228.117.527.117 1.124.117h1.492m1.706 3.198h4.051c.597 0 .896 0 1.124-.116.2-.103.363-.266.466-.466.116-.228.116-.527.116-1.124v-4.051c0-.597 0-.896-.116-1.124a1.07 1.07 0 0 0-.466-.466c-.228-.116-.527-.116-1.124-.116h-4.051c-.597 0-.896 0-1.124.116-.2.103-.363.266-.466.466-.116.228-.116.527-.116 1.124v4.051c0 .597 0 .896.116 1.124.103.2.266.363.466.466.228.116.527.116 1.124.116"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_7203_6807">
          <path fill="#fff" d="M11.207 10.104H24v12.793H11.207z"></path>
        </clipPath>
        <filter
          id="filter0_dd_7203_6807"
          width="35.189"
          height="35.989"
          x="0.009"
          y="0.504"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.8"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.02 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7203_6807"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="2.399"></feOffset>
          <feGaussianBlur stdDeviation="1.599"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.04 0"></feColorMatrix>
          <feBlend
            in2="effect1_dropShadow_7203_6807"
            result="effect2_dropShadow_7203_6807"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_7203_6807"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  ),
  vArrowDown: (param?: any) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        fill="none"
        viewBox="0 0 24 25"
        className="img"
      >
        <path
          stroke={param || "#000"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="m6 9.5 6 6 6-6"
        ></path>
      </svg>
    );
  },
  manageStreamIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="22"
      fill="none"
      viewBox="0 0 18 22"
      className="img"
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M11 10H5m2 4H5m8-8H5m12-.2v10.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C14.72 21 13.88 21 12.2 21H5.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C1 18.72 1 17.88 1 16.2V5.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C3.28 1 4.12 1 5.8 1h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C17 3.28 17 4.12 17 5.8"
      ></path>
    </svg>
  ),
  streamKeyBlack: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M15 7c0-.512-.195-1.024-.586-1.414A2 2 0 0 0 13 5m0 8a6 6 0 1 0-5.946-5.193c.058.434.087.651.068.789a.85.85 0 0 1-.117.346c-.068.121-.187.24-.426.479l-5.11 5.11c-.173.173-.26.26-.322.36a1 1 0 0 0-.12.29C1 15.296 1 15.418 1 15.663V17.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C1.76 19 2.04 19 2.6 19H5v-2h2v-2h2l1.58-1.58c.238-.238.357-.357.478-.425a.85.85 0 0 1 .346-.117c.138-.02.355.01.789.068Q12.589 13 13 13"
      ></path>
    </svg>
  ),
  plainEditPen: (param?: any) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 20 20"
      >
        <path
          stroke={param || "#000"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M10 16.666h7.5m-15 0h1.395c.408 0 .612 0 .804-.046q.256-.061.482-.2c.168-.103.312-.247.6-.535L16.25 5.416a1.768 1.768 0 1 0-2.5-2.5L3.281 13.386c-.288.287-.432.432-.535.6q-.139.225-.2.481c-.046.192-.046.396-.046.804z"
        ></path>
      </svg>
    );
  },
  arrowRight: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        stroke="#002856"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M3 9h12m0 0-4.5-4.5M15 9l-4.5 4.5"
      ></path>
    </svg>
  ),
  contactTwoHeads: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
    >
      <circle cx="11" cy="11" r="11" fill="#F7F7F7"></circle>
      <path
        stroke="#8B8B8B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.097"
        d="M12.938 6.438a2.41 2.41 0 0 1 1.305 2.156c0 .945-.531 1.762-1.305 2.156m1.044 2.799c.79.365 1.5.961 2.089 1.729m-10.443 0c1.016-1.325 2.396-2.14 3.916-2.14s2.9.815 3.916 2.14m-1.566-6.684c0 1.329-1.052 2.406-2.35 2.406s-2.35-1.077-2.35-2.406 1.052-2.406 2.35-2.406 2.35 1.077 2.35 2.406"
      ></path>
    </svg>
  ),
  threeDot: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
    >
      <circle cx="11" cy="11" r="11" fill="#F7F8F7"></circle>
      <path
        stroke="#1B1B1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11 11.459a.458.458 0 1 0 0-.917.458.458 0 0 0 0 .917M14.209 11.459a.458.458 0 1 0 0-.917.458.458 0 0 0 0 .917M7.792 11.459a.458.458 0 1 0 0-.917.458.458 0 0 0 0 .917"
      ></path>
    </svg>
  ),
  virtualTerminal: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#002856"
        d="M16 2H8C5.24 2 3 4.24 3 7v10c0 2.76 2.24 5 5 5h8c2.76 0 5-2.24 5-5V7c0-2.76-2.24-5-5-5M8.86 18.63c-.19.19-.44.29-.7.29a1 1 0 0 1-.71-.29 1 1 0 0 1-.3-.71c0-.26.11-.52.3-.71.09-.09.2-.16.32-.21.25-.1.52-.1.77 0 .06.02.12.05.17.09.06.03.11.08.15.12.19.19.3.45.3.71a1 1 0 0 1-.3.71m-1.71-4.71c0-.13.03-.26.08-.38A.998.998 0 0 1 8.54 13c.06.02.12.05.17.09.06.03.11.08.15.12.09.1.17.2.22.33.05.12.07.25.07.38a.99.99 0 0 1-1.38.92 1 1 0 0 1-.62-.92m5.71 4.71c-.09.09-.2.16-.32.21s-.25.08-.39.08c-.26 0-.51-.1-.7-.29a1 1 0 0 1-.3-.71c0-.07.01-.13.02-.2l.06-.18.09-.18c.04-.05.08-.1.13-.15a1.017 1.017 0 0 1 1.41 0c.19.19.29.45.29.71 0 .27-.1.52-.29.71m0-4a1 1 0 0 1-.71.29c-.26 0-.51-.1-.7-.29a1 1 0 0 1-.3-.71c0-.26.11-.52.3-.71.37-.37 1.04-.37 1.41 0 .09.1.17.2.22.33.05.12.07.25.07.38 0 .27-.1.52-.29.71M9 10.46c-1.03 0-1.88-.84-1.88-1.88v-1c0-1.03.84-1.88 1.88-1.88h6c1.03 0 1.88.84 1.88 1.88v1c0 1.03-.84 1.88-1.88 1.88zm7.86 8.17a.99.99 0 0 1-1.09.21 1 1 0 0 1-.32-.21 1 1 0 0 1-.29-.71c0-.26.1-.52.29-.71.27-.28.72-.36 1.09-.21.12.05.23.12.32.21.19.19.29.45.29.71 0 .27-.1.52-.29.71m.22-4.33a.99.99 0 0 1-.93.62c-.26 0-.51-.1-.7-.29a1 1 0 0 1-.3-.71c0-.26.11-.52.3-.71.37-.37 1.04-.37 1.41 0 .19.19.3.45.3.71 0 .13-.03.26-.08.38"
      ></path>
    </svg>
  ),
  naira: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66602 6H3.99935V2H5.33268L7.61268 6H10.666V2H11.9993V6H13.3327V7.33333H11.9993V8.66667H13.3327V10H11.9993V14H10.666L8.37935 10H5.33268V14H3.99935V10H2.66602V8.66667H3.99935V7.33333H2.66602V6ZM5.33268 6H6.08602L5.33268 4.68667V6ZM5.33268 7.33333V8.66667H7.61268L6.85268 7.33333H5.33268ZM10.666 11.3333V10H9.89935L10.666 11.3333ZM8.37268 7.33333L9.13935 8.66667H10.666V7.33333H8.37268Z"
        fill="#333333"
      />
    </svg>
  ),
  transactionFee: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#333"
        d="M8 1.333A6.67 6.67 0 0 0 1.335 8a6.67 6.67 0 0 0 6.667 6.666A6.67 6.67 0 0 0 14.667 8a6.67 6.67 0 0 0-6.666-6.667m-2 4c.367 0 .667.3.667.667a.664.664 0 0 1-.666.666A.67.67 0 0 1 5.334 6c0-.367.3-.667.667-.667m.354 5.02a.495.495 0 0 1-.707 0 .503.503 0 0 1 0-.707l4-4a.503.503 0 0 1 .707 0 .503.503 0 0 1 0 .707zm3.647.313A.67.67 0 0 1 9.327 10c0-.367.3-.667.667-.667s.667.3.667.667a.663.663 0 0 1-.66.666"
      ></path>
    </svg>
  ),

  dedicatedUser: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      fill="none"
      viewBox="0 0 16 17"
    >
      <path
        fill="#292D32"
        d="M12 2.5H4a2.657 2.657 0 0 0-2.666 2.647v6.706A2.657 2.657 0 0 0 4.001 14.5h8a2.657 2.657 0 0 0 2.666-2.647V5.147A2.657 2.657 0 0 0 12.001 2.5M5.668 5.28c.847 0 1.54.693 1.54 1.54s-.693 1.54-1.54 1.54c-.846 0-1.54-.693-1.54-1.54s.694-1.54 1.54-1.54m2.58 6.327a.34.34 0 0 1-.246.106H3.334a.34.34 0 0 1-.247-.106.35.35 0 0 1-.086-.254A2.366 2.366 0 0 1 5.127 9.24c.354-.033.72-.033 1.074 0a2.36 2.36 0 0 1 2.126 2.113.32.32 0 0 1-.08.254m4.42.06h-1.333a.504.504 0 0 1-.5-.5c0-.274.227-.5.5-.5h1.333c.274 0 .5.226.5.5 0 .273-.226.5-.5.5m0-2.667h-2.666a.504.504 0 0 1-.5-.5c0-.273.226-.5.5-.5h2.666c.274 0 .5.227.5.5s-.226.5-.5.5m0-2.667H9.334a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h3.333c.274 0 .5.227.5.5 0 .274-.226.5-.5.5"
      ></path>
    </svg>
  ),
  connectedAlerts: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      fill="none"
      viewBox="0 0 16 17"
    >
      <path
        fill="#292D32"
        d="M12 1.833H4c-1.107 0-2 .887-2 1.98v7.273c0 1.094.893 1.98 2 1.98h.507c.533 0 1.04.207 1.413.58l1.14 1.127c.52.513 1.367.513 1.887 0l1.14-1.127c.373-.373.886-.58 1.413-.58h.5c1.107 0 2-.886 2-1.98V3.813c0-1.093-.893-1.98-2-1.98m-4 2.5c.86 0 1.553.693 1.553 1.553A1.55 1.55 0 0 1 8 7.44c-.86 0-1.553-.7-1.553-1.554 0-.86.693-1.553 1.553-1.553m1.787 6.207H6.213a.67.67 0 0 1-.553-1.047C6.113 8.82 6.993 8.366 8 8.366s1.887.454 2.34 1.127a.671.671 0 0 1-.553 1.047"
      ></path>
    </svg>
  ),
  flash: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      fill="none"
      viewBox="0 0 16 17"
    >
      <path
        fill="#292D32"
        d="M8 1.833A6.67 6.67 0 0 0 1.335 8.5a6.67 6.67 0 0 0 6.667 6.666A6.67 6.67 0 0 0 14.667 8.5a6.67 6.67 0 0 0-6.666-6.667m2.354 7.487-3.453 2.393c-.507.353-.8.147-.654-.447l.634-2.56-1.1-.273c-.5-.12-.56-.467-.14-.76L9.094 5.28c.507-.354.8-.147.653.446l-.633 2.56 1.1.274c.5.126.56.466.14.76"
      ></path>
    </svg>
  ),
  accountFlier: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      fill="none"
      viewBox="0 0 16 17"
    >
      <path
        fill="#292D32"
        d="M10.794 1.833H5.207c-2.426 0-3.873 1.447-3.873 3.873v5.58c0 2.434 1.447 3.88 3.873 3.88h5.58c2.427 0 3.874-1.446 3.874-3.873V5.706c.006-2.426-1.44-3.873-3.867-3.873M11.334 12H4.667a.504.504 0 0 1-.5-.5c0-.274.227-.5.5-.5h6.667c.273 0 .5.226.5.5 0 .273-.227.5-.5.5m0-3H4.667a.504.504 0 0 1-.5-.5c0-.274.227-.5.5-.5h6.667c.273 0 .5.226.5.5 0 .273-.227.5-.5.5m0-3H4.667a.504.504 0 0 1-.5-.5c0-.274.227-.5.5-.5h6.667c.273 0 .5.226.5.5 0 .273-.227.5-.5.5"
      ></path>
    </svg>
  ),
  generateAccount: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <path
        fill="var(--primary-base-color)"
        d="M15.48 2.9H7.53c-3.46 0-5.52 2.06-5.52 5.52v7.95c0 3.46 2.07 5.52 5.52 5.52h7.95c3.46 0 5.52-2.06 5.52-5.52V8.42c0-3.46-2.07-5.52-5.52-5.52"
        opacity="0.4"
      ></path>
      <path
        fill="var(--primary-base-color)"
        d="m21.96 19.74-1.63.55c-.45.15-.81.5-.96.96l-.55 1.63c-.47 1.41-2.45 1.38-2.89-.03l-1.85-5.95c-.36-1.18.73-2.28 1.9-1.91l5.96 1.85c1.4.44 1.42 2.43.02 2.9"
      ></path>
    </svg>
  ),
  ring: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        stroke="#333"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.92 3.791c.51.102.979.358 1.346.734s.617.856.717 1.378M7.92 1.653c1.06.12 2.048.606 2.802 1.377a4.86 4.86 0 0 1 1.35 2.868M5.923 7.996a7.8 7.8 0 0 1-1.486-2.144c-.031-.067-.047-.1-.06-.143a.57.57 0 0 1 .078-.46c.025-.036.055-.067.114-.128.183-.187.274-.28.334-.374a1.09 1.09 0 0 0 0-1.166c-.06-.094-.151-.188-.334-.375l-.102-.104c-.277-.284-.416-.426-.565-.503a1.02 1.02 0 0 0-.942 0c-.15.077-.288.219-.566.503l-.082.084c-.277.284-.415.425-.52.618a1.84 1.84 0 0 0-.201.79c0 .221.042.372.126.674a10.24 10.24 0 0 0 2.545 4.43 9.9 9.9 0 0 0 4.325 2.605c.295.086.442.129.658.13.239 0 .563-.086.771-.206.189-.108.327-.25.603-.533l.083-.084c.277-.285.416-.427.491-.58.15-.303.15-.661 0-.965-.075-.152-.214-.294-.491-.579l-.102-.104c-.183-.187-.274-.28-.366-.341a1.02 1.02 0 0 0-1.138 0c-.092.06-.183.154-.366.341-.06.061-.09.092-.124.118a.54.54 0 0 1-.45.078 1 1 0 0 1-.14-.06 7.6 7.6 0 0 1-2.093-1.522"
      ></path>
    </svg>
  ),

  tidIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        stroke="#8B8B8B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.8"
        d="M3.717 8.604v2.887c0 .3 0 .45.057.564.05.1.13.182.228.233.112.059.258.059.55.059h4.595c.293 0 .439 0 .55-.059a.53.53 0 0 0 .229-.233c.057-.115.057-.264.057-.564V8.604m-2.09 1.604v.534m-2.088-.534v.534m2.716-9.09H5.179c-.878 0-1.316 0-1.651.175-.295.154-.535.4-.685.701-.17.343-.17.792-.17 1.69v2.675c0 .598 0 .898.113 1.127.1.2.26.365.457.467.223.117.515.117 1.1.117h5.013c.585 0 .877 0 1.1-.117.197-.102.357-.266.457-.467.114-.23.114-.529.114-1.127V4.219c0-.899 0-1.348-.17-1.69a1.6 1.6 0 0 0-.685-.702c-.336-.175-.774-.175-1.651-.175"
      ></path>
    </svg>
  ),
};
export default Icons;
